/**
 * Содержит набор enums для FillingFormType
 * @module Enums FillingFormType
  */

/**
 * Типы заполняемой формы сообщений
 * @readonly
 * @enum {string}
 */
export const FillingFormType = Object.freeze({
  /** Регистрация пользователя
   *  @type {string} */
  PERSONAL_REGISTRATION: 'personalRegistration',
  /** Режим администратора
   *  @type {string} */
  ADMIN_EDIT: 'adminEdit',
  /** регистрация на месте
   *  @type {string} */
  MANUAL_REGISTRATION: 'manualRegistration',
  /** Режим просмотра
   *  @type {string} */
  SHOW: 'show',
})
